import axios from "axios";

window.onlineSalesServerGET = (route , queryParams = ``) => {
    if (queryParams&&queryParams.trim() !== '')queryParams = "?"+queryParams;
    let finalRoute = route+queryParams;
    return axios.get(serverApiGET, {params: {route: finalRoute}})
        .catch((err) => errorHandler.tomcatError(err))
}